// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"51ab97bc","941":"e6b77051"}[chunkId] + ".chunk.css";
};